module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0146.jpg?v=62ca6a52";